import { app } from '../../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-group.accounts.add', {
        url: '/add',
        views: {
            '@company.user-directories.manage-group': 'companyUserDirectoriesManageGroupAccountsAdd'
        },
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/accounts/add/add-account-to-group.state.js